import VueCookie from 'vue-cookie';

export class AuthService {
    static setToken(token){
        VueCookie.set('token', token);
    }
    static getToken(){
        return VueCookie.get('token');
    }
    static deleteToken(){
        return VueCookie.delete('token');   
    }
    static setUid(uid){
        VueCookie.set('uid', uid);
    }
    static getUid(){
        return VueCookie.get('uid');
    }
    static deleteUid(){
        return VueCookie.delete('uid');
    }
    static getCollaborateBid(){
        return VueCookie.get('collaboratebid');
    }
    static setCollaborateBid(collaboratebid){
        VueCookie.set('collaboratebid', collaboratebid);
    }
    static deleteCollaborateBid(){
        return VueCookie.delete('collaboratebid');
    }
    static getCollaborateUid(){
        return VueCookie.get('collaborateuid');
    }
    static setCollaborateUid(collaborateuid){
        VueCookie.set('collaborateuid', collaborateuid);
    }
    static deleteCollaborateUid(){
        return VueCookie.delete('collaborateuid');
    }
    static setTipusEntitat(tipusEntitat){
        VueCookie.set('tipusEntitat', tipusEntitat);
    }
    static getTipusEntitat(){
        return VueCookie.get('tipusEntitat');
    }
    static deleteTipusEntitat(){
        return VueCookie.delete('tipusEntitat');
    }
}




// WEBPACK FOOTER //
// ./src/login/services/authService.js